import React from 'react';

const Browse = () => (
  <div style={{ padding:'1rem' }}>
    <h1 style={{ marginTop:0 }}>Browse Products</h1>
    <p>Product discovery, search filters, and supplier profiles coming soon.</p>
  </div>
);

export default Browse;
